import { useEffect, useState, useRef } from "react";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_CAMPAIGN_FORM_STEPS,
  ATTACHMENT_FILE_TYPES,
  CAMPAIGN_TYPES,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import {
  getErrorMessage,
  //isNameValid,
  isRequired,
  isHtmlValid,
  isTextMessageValid,
  isFileSizeValid,
  isFileTypeValid,
  isLengthValid,
  isLengthCharValid,
} from "../../../../../utils/FormUtils";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "../WizardForm.module.css";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import AttachmentInput from "../../../Inputs/CustomInputs/AttachmentInput";
import { Button } from "@mui/material";
import { CAMPAIGN_TYPE_LIST } from "../../../../../constants/Constants";
import { downloadAttachmentByCampaignId } from "../../../../../utils/MenuUtils";
import { LENGTHS } from "../../../../../config/Config";
import { InputInfo } from "../../../../../entities/UIEntities/Form Entities/InputInfo";
import useInputInfos from "../../../../../hooks/useInputInfos";
import CustomTooltip from "../../../Tooltip/CustomTooltip/CustomTooltip";
import { showCampaignErrorMessage } from "../../../../../utils/MessagesUtils";

const CampaignDetailsStep = (props) => {
  const { inputInfos, setInputInfos, handleInputInfo, getInputsStatusByInputInfos } = useInputInfos();
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    props?.isEditMode ? props?.isDuplicateMode ? Strings.STEPS_TITLES.CAMPAIGN_DETAILS_DUPLICATE_TITLE : Strings.STEPS_TITLES.CAMPAIGN_DETAILS_EDIT_TITLE : Strings.STEPS_TITLES.CREATE_NEW_CAMPAIGN_TITLE,
    null,
    Icons.MESSAGING,
    null
  ));

  const attachmentInputRef = useRef();
  const hasFileError = Array.isArray(props.attachment) && (!isFileSizeValid(props.attachment[0]?.size, LENGTHS.MAX_ATTACHMENT_FILE_SIZE).isValid || !isFileTypeValid(props.attachment[0]?.name, ATTACHMENT_FILE_TYPES).isValid)
  const fileErrorMessage = Array.isArray(props.attachment) && (getErrorMessage(isFileSizeValid(props.attachment[0]?.size, LENGTHS.MAX_ATTACHMENT_FILE_SIZE)) || getErrorMessage(isFileTypeValid(props.attachment[0]?.name, ATTACHMENT_FILE_TYPES)))
  const fileName = props.attachmentName ? props.attachmentName : Strings.EXISTING_FILE_NAME;

  useEffect(() => {
    if (props.currentStep === ADD_CAMPAIGN_FORM_STEPS.CAMPAIGN_DETAILS) {
      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
    }
  }, [props.currentStep]); 

  useEffect(() => {
    if (props.currentStep === ADD_CAMPAIGN_FORM_STEPS.CAMPAIGN_DETAILS) {
      const { hasValue, hasError } = getInputsStatusByInputInfos(inputInfos);
      props.handleStateDataChange({["isCurrentStepValid"]: !hasError, ["isCurrentStepHasValues"]: hasValue });
    }
  }, [inputInfos]);

  useEffect(() => {
    // If added file has any error, shows the error in a message modal 
    // and automatically clears the file from input
    if (props.attachment?.length > 0 && hasFileError) {
      showCampaignErrorMessage({"errorTitle" : fileErrorMessage});
      attachmentInputRef?.current?.handleFileClear();
    }
  }, [props.attachment]);

  const getMessageBodyErrorMessage = () => {
    let errorMessage = "";

    if (getErrorMessage(isRequired(props.messageBody))) {
      errorMessage = getErrorMessage(isRequired(props.messageBody));
    }
    else {
      // if input exists, check mail / text message case with different params
      if (props?.campaignType?.value === CAMPAIGN_TYPES.MAIL) {
        errorMessage = getErrorMessage(isHtmlValid(props.messageBody)) ? getErrorMessage(isHtmlValid(props.messageBody)) : getErrorMessage(isLengthValid(props.messageBody, LENGTHS.MAX_HTML_BODY_MESSAGE_LENGTH)) ? getErrorMessage(isLengthValid(props.messageBody, LENGTHS.MAX_HTML_BODY_MESSAGE_LENGTH, true)) : errorMessage;
      }
      else {
        errorMessage = getErrorMessage(isTextMessageValid(props.messageBody)) ? getErrorMessage(isTextMessageValid(props.messageBody)) : getErrorMessage(isLengthValid(props.messageBody, LENGTHS.MAX_TEXT_MESSAGE_LENGTH)) ? getErrorMessage(isLengthValid(props.messageBody, LENGTHS.MAX_TEXT_MESSAGE_LENGTH)) : errorMessage;
      }
    }

    return errorMessage;
  };

  if (props.currentStep !== ADD_CAMPAIGN_FORM_STEPS.CAMPAIGN_DETAILS) {
    return null;
  }
  
  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {props?.isEditMode ? props?.isDuplicateMode ? Strings.STEPS_TITLES.CAMPAIGN_DETAILS_DUPLICATE_TITLE : Strings.STEPS_TITLES.CAMPAIGN_DETAILS_EDIT_TITLE : Strings.STEPS_TITLES.CAMPAIGN_DETAILS_NEW_TITLE}
      </div>
      <div className={classes.fileds}>
        <SelectInput
          label={Strings.INPUT_LABELS.CAMPAIGN_TYPE}
          id={INPUTS_PROPS.CAMPAIGN_TYPE}
          onChange={(event) => {
            // passes the selection as the ListItem
            //event[INPUTS_PROPS.CAMPAIGN_TYPE] = CAMPAIGN_TYPE_LIST.find(i => i.value === Object.values(event)[0]);
            //props.handleChange(event);

            // changes type, reset any other form fields
            props.handleChange({
              [INPUTS_PROPS.CAMPAIGN_TYPE]: CAMPAIGN_TYPE_LIST.find(i => i.value === Object.values(event)[0]),
              [INPUTS_PROPS.CAMPAIGN_NAME] : "",
              [INPUTS_PROPS.EMAIL_SUBJECT]: "",
              [INPUTS_PROPS.MESSAGE_BODY] : "",
              [INPUTS_PROPS.ATTACHMENT]: [],
              [INPUTS_PROPS.IS_STEP_SUBMITTED] : false
            });

            // when campaign type is text message, emailSubject input checks is not needed
            const inputInfosCopy = [...inputInfos]?.map(i => {
              // reset input infos on every campaignType change
              if (i.field === INPUTS_PROPS.CAMPAIGN_TYPE) {
                // set campaign type changed value
                return new InputInfo(i.field, Object.values(event)[0], i.isRequired, i.hasError);
              }
              else if (i.field === INPUTS_PROPS.EMAIL_SUBJECT) {
                // handle email subject, disabled on text message, enabled on email type
                if (event[INPUTS_PROPS.CAMPAIGN_TYPE] === CAMPAIGN_TYPES.MOBILE) {
                  return new InputInfo(i.field, "", false, false);
                }
                else {
                  return new InputInfo(i.field, "", true, false);
                }
              }
              else {
                // reset values & errors, for the rest input infos
                return new InputInfo(i.field, Array.isArray(i.value) ? [] : "", i.isRequired, false);
              }
            });
            
            setInputInfos(inputInfosCopy);
          }}
          list={CAMPAIGN_TYPE_LIST} 
          value={props?.campaignType?.value ? props?.campaignType?.value : ''}
          defaultValue={''}
          isStepSubmitted={props.isStepSubmitted}
          //hasError={!isRequired(props.scopeType).isValid}
          //errorMessage={getErrorMessage(isRequired(props.scopeType.name))}
          isRequired={true}
          handleInputInfo={handleInputInfo}
        />
        <TextInput
          label={`${Strings.INPUT_LABELS.CAMPAIGN_NAME}*`}
          id={INPUTS_PROPS.CAMPAIGN_NAME}
          value={props.campaignName}
          defaultValue={props.campaignName}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          isRequired={true}
          handleInputInfo={handleInputInfo}
          hasError={!isRequired(props.campaignName).isValid || !isLengthCharValid(props.campaignName, LENGTHS.MAX_INPUT_LENGTH).isValid}
          errorMessage={getErrorMessage(isRequired(props.campaignName)) ? getErrorMessage(isRequired(props.campaignName)) : 
                        getErrorMessage(isLengthCharValid(props.campaignName, LENGTHS.MAX_INPUT_LENGTH)) && 
                        getErrorMessage(isLengthCharValid(props.campaignName, LENGTHS.MAX_INPUT_LENGTH))}
                        
        />
        {props?.campaignType?.value === CAMPAIGN_TYPES.MAIL && (
            <TextInput
              label={`${Strings.INPUT_LABELS.EMAIL_SUBJECT}*`}
              id={INPUTS_PROPS.EMAIL_SUBJECT}
              value={props.emailSubject}
              onChange={props.handleChange}
              isStepSubmitted={props.isStepSubmitted}
              isRequired={true}
              handleInputInfo={handleInputInfo}
              hasError={!isRequired(props.emailSubject).isValid || !isLengthCharValid(props.emailSubject, LENGTHS.MAX_INPUT_LENGTH).isValid}
              errorMessage={getErrorMessage(isRequired(props.emailSubject)) ? getErrorMessage(isRequired(props.emailSubject)) : 
                getErrorMessage(isLengthCharValid(props.emailSubject, LENGTHS.MAX_INPUT_LENGTH)) && 
                getErrorMessage(isLengthCharValid(props.emailSubject, LENGTHS.MAX_INPUT_LENGTH))}
            />
        )}
        <TextInput
          classesToAdd={classes.messageBodyField}
          label={props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? `${Strings.INPUT_LABELS.EMAIL_BODY}*` : `${Strings.INPUT_LABELS.TEXT_BODY}*`}
          id={INPUTS_PROPS.MESSAGE_BODY}
          defaultValue={''}
          maxRows={11}
          excludeHtmlTags={props?.campaignType?.value === CAMPAIGN_TYPES.MAIL}

          showCharCounter={true}
          charCounterLimit={props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? LENGTHS.MAX_HTML_BODY_MESSAGE_LENGTH : LENGTHS.MAX_TEXT_MESSAGE_LENGTH}
          charCounterDisplaySx={props?.campaignType?.value === CAMPAIGN_TYPES.MAIL && {marginTop: '10px'}}

          showTooltip={props?.campaignType?.value === CAMPAIGN_TYPES.MOBILE}
          tooltipTitle={props?.campaignType?.value === CAMPAIGN_TYPES.MOBILE && Strings.TOOLTIP_INFO_TITLE.TEXT_MESSAGE}
          tooltipText={props?.campaignType?.value === CAMPAIGN_TYPES.MOBILE && Strings.TOOLTIP_INFO_TEXT.TEXT_MESSAGE}
          tooltipButtonSx={props?.campaignType?.value === CAMPAIGN_TYPES.MOBILE && {position: 'absolute', top: '120px', right: '-40px'}}

          isEditable={props?.campaignType?.value === CAMPAIGN_TYPES.MAIL}
          value={props.messageBody}
          onChange={props.handleChange}
          onPaste={() => showCampaignErrorMessage({"errorTitle" : props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? 
          `${Strings.INPUT_ERROR_MESSAGES.INVALID_PASTED_LENGTH}`.format(`${LENGTHS.MAX_HTML_BODY_MESSAGE_LENGTH}`) : 
          `${Strings.INPUT_ERROR_MESSAGES.INVALID_PASTED_LENGTH}`.format(`${LENGTHS.MAX_TEXT_MESSAGE_LENGTH}`)})}
          isStepSubmitted={props.isStepSubmitted}
          isRequired={true}
          handleInputInfo={handleInputInfo}
          hasError={!isRequired(props.messageBody).isValid || props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? 
                    !isHtmlValid(props.messageBody).isValid || !isLengthValid(props.messageBody, LENGTHS.MAX_HTML_BODY_MESSAGE_LENGTH, true).isValid : 
                    !isTextMessageValid(props.messageBody).isValid || !isLengthValid(props.messageBody, LENGTHS.MAX_TEXT_MESSAGE_LENGTH).isValid}
          errorMessage={getMessageBodyErrorMessage()}
        />
        {/* <TextInput
          label={Strings.INPUT_LABELS.LINK}
          id={INPUTS_PROPS.LINK}
          value={props.link}
          isStepSubmitted={props.isStepSubmitted}
          onChange={props.handleChange}
          handleInputInfo={handleInputInfo}
          hasError={!isRequired(props.link).isValid || !isNameValid(props.link).isValid}
          errorMessage={getErrorMessage(isRequired(props.link)) ? getErrorMessage(isRequired(props.link)) : getErrorMessage(isNameValid(props.link))}
        />   */}
        {/* <TextInput
          label={Strings.INPUT_LABELS.GENERATED_LINK}
          id={INPUTS_PROPS.GENERATED_LINK}
          value={props.generatedLink}
          isStepSubmitted={props.isStepSubmitted}
          onChange={props.handleChange}
          handleInputInfo={handleInputInfo}
          hasError={!isRequired(props.generatedLink).isValid || !isNameValid(props.generatedLink).isValid}
          errorMessage={getErrorMessage(isRequired(props.generatedLink)) ? getErrorMessage(isRequired(props.generatedLink)) : getErrorMessage(isNameValid(props.generatedLink))}
        />    */}
        {props?.campaignType?.value === CAMPAIGN_TYPES.MAIL && (
          <>
            <div className={classes.attachmentContainer}>
              <div className={classes.stepTitle}>
                    {Strings.STEPS_TITLES.ATTACHMENT_TITLE}
                    <CustomTooltip 
                      tooltipTitle={Strings.TOOLTIP_INFO_TITLE.ATTACHMENT}
                      tooltipText={Strings.TOOLTIP_INFO_TEXT.ATTACHMENT.format(LENGTHS.MAX_ATTACHMENT_FILE_SIZE)}
                    />
              </div>
                <div className={classes.uploadImage}>
                    <AttachmentInput 
                        id={INPUTS_PROPS.ATTACHMENT}
                        ref={attachmentInputRef}
                        accept={Object.values(ATTACHMENT_FILE_TYPES)?.join(",")}
                        defaultValue={props.attachment}
                        onChange={props.handleChange}
                        attachment={props.attachment}
                        isEditMode={props.isEditMode}
                        isStepSubmitted={props.isStepSubmitted}
                        handleInputInfo={handleInputInfo}
                        hasError={props.attachment?.length > 0 && hasFileError}
                        errorMessage={props.attachment?.length > 0 && fileErrorMessage}
                    />
              </div>
            </div>
            {/* File error message text */}
            {/* {props.isStepSubmitted && props.attachment?.length > 0 && hasFileError ? (
              <div className={classes.error}>
                {props.attachment?.length > 0 && fileErrorMessage}
              </div> 
            ) : ""} */}
          </>
        )} 
        
        {/* File preview - if there is any error file preview won't be shown */}
        {props?.attachment?.length > 0 && !hasFileError && (
          <div className={classes.fileContainer}>
            {props.isEditMode ? (
              <>
                 {/* Can download only if file already exists on db (its format is string, and not array)*/}
                 {!Array.isArray(props.attachment) ? (
                    <>
                      <h6>{fileName}</h6>
                      <Button onClick={() => downloadAttachmentByCampaignId(props?.campaignId, fileName)} sx={{minWidth: '30px'}}>
                        <img src={Icons.DOWNLOAD}></img>
                      </Button>
                    </>
                 ) : 
                    <h6>{props?.attachment[0]?.name}</h6>
                 }
              </>
            ):
              <h6>{props?.attachment[0]?.name}</h6>
            }
            {/* Delete option will appear once any file exists (exists file from db or client's new file / replaced file, and in any mode)*/}
            <Button onClick={attachmentInputRef?.current?.handleFileClear} sx={{minWidth: '30px', marginLeft: '10px'}}>
                <img src={Icons.DELETE_ITEM_4} />
            </Button> 
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignDetailsStep;
